// src/pages/SpendVsConsumed.jsx
// Similar to above, but Line chart with two datasets: total amount (spend), consumed amount (status != Expired)
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import useFetch from '../../hooks/useFetch';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const SmartySpendVsConsumed = () => {
  // ... similar setup ...
  useEffect(() => {
    // Fetch two aggregates: one for all amount, one for status != Expired
    // For simplicity, assume backend returns { spend: [...], consumed: [...] }
    const config = {
      url: "/smartyitems/aggregate",
      method: "post",
      headers: { Authorization: token },
      data: { userId: user._id, year: currentYear, groupBy: 'month', sums: ['amount', { amount_consumed: { sum: 'amount', status_ne: 'Expired' } }] }
    };
    // Set datasets: [{ label: 'Spend', data: spendData }, { label: 'Consumed', data: consumedData }]
  }, []);
  // Render <Line data={chartData} ... />
};

export default SmartySpendVsConsumed;